import { render, staticRenderFns } from "./ShippingAddressFormTab.vue?vue&type=template&id=e53eaa42"
import script from "./ShippingAddressFormTab.vue?vue&type=script&lang=js"
export * from "./ShippingAddressFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports